import { Controller, UseFormSetValue } from 'react-hook-form';
import { Autocomplete } from '@mui/material';
import { countryCodes, countryNameByCode } from '~/adapters/geography/countriesAndProvinces';
import { AddressDialogFieldProps, AddressFormState } from '../../types';
import { requiredErrorMessage, tooLongErrorMessage } from '../constants';
import { AutofillTextField } from '../AutofillTextField';

/* eslint-disable react/jsx-props-no-spreading */

// there is no Autocomplete component in Pigment, have to use MUI Autocomplete for this filed
// we are trying out the Autocomplete UX, with the end goal to either incorporate it in Pigment or drop it
// note: the Theme definition for MUI Autocomplete currently lives in AmendedThemeProvider
export type AddressCountryProps = AddressDialogFieldProps & { setValue: UseFormSetValue<AddressFormState> };
export const AddressCountry = ({ control, setValue }: AddressCountryProps) => (
    <Controller
        name="addressCountry"
        control={control}
        rules={{ required: requiredErrorMessage, maxLength: { value: 50, message: tooLongErrorMessage } }}
        render={({ field: { onChange, value, ...field } }) => (
            <Autocomplete
                autoSelect
                autoHighlight
                options={countryCodes}
                getOptionLabel={(option) => countryNameByCode[option] ?? option}
                value={value}
                // on Country change also reset addressRegion, because there are now different options
                onChange={(_event, newValue) => {
                    onChange(newValue);
                    setValue('addressRegion', '');
                }}
                renderInput={(params) => (
                    <AutofillTextField {...params} autoFillKey="country-name" label="Country / Region" />
                )}
                {...field}
            />
        )}
    />
);
